// removed by extract-text-webpack-plugin
module.exports = {"portal":"portal__sr76K09RbyMX"};